module.exports = __webpack_public_path__ + "static/media/mapa-nuevo.178a2faf.svg";